import { TeamCreditsStackSourceEnum } from "@/enums/team-credits";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamCreditsStackDTO } from "@shaarp/common";
import { GiftIcon, Loader2Icon, ReceiptEuroIcon } from "lucide-react";

type TeamCreditsProgressProps = {
  stack: TeamCreditsStackDTO | undefined;
  source: string;
};

export function TeamCreditsProgress({
  stack,
  source,
}: TeamCreditsProgressProps) {
  const { t } = useTranslation();
  const percentage =
    stack && stack.totalAdded > 0
      ? (stack.totalUsed / stack.totalAdded) * 100
      : 0;

  const label = stack ? `${stack.totalUsed} / ${stack.totalAdded}` : null;

  return (
    <div className="mb-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center w-1/6 gap-2 text-sm font-medium capitalize text-muted-foreground">
          {source === TeamCreditsStackSourceEnum.GIFT ? (
            <GiftIcon className="w-5 h-5 text-muted-foreground" />
          ) : (
            <ReceiptEuroIcon className="w-5 h-5 text-muted-foreground" />
          )}
          {t(`team.credits.stack.${source}`)}
        </div>
        <div className="relative h-8 overflow-hidden rounded-md w-96 bg-secondary">
          <div
            className="h-full transition-all duration-500 ease-in-out bg-primary"
            style={{ width: `${percentage}%` }}
          />
          <span className="absolute inset-0 flex items-center px-3 text-sm font-medium text-secondary-foreground">
            {label ?? <Loader2Icon className="w-4 h-4 animate-spin" />}
          </span>
          <span
            className="absolute inset-0 flex items-center px-3 text-sm font-medium text-primary-foreground"
            style={{ clipPath: `inset(0 ${100 - percentage}% 0 0)` }}
          >
            {label}
          </span>
        </div>
      </div>
    </div>
  );
}
